import { faArrowRight, faTimesCircle } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useRef } from 'react';
import FocusLock from 'react-focus-lock';

import './Modal.css';

import { useTranslation } from 'react-i18next';

import { Button } from '../components/button/Button';
import useKeyboardAction from '../hooks/useKeyboardAction';
import Backdrop from '../menu/Backdrop';

function Modal(props) {
  const { t } = useTranslation();
  const buttonRef = useRef(null);
  const modalRef = useRef(null);
  const pageContents = {
    sub_title: t('MH003'),
    title: t('MH004'),
    text1: t('MH005'),
    text2: t('MH006'),
    buttonText: t('MH007'),
  };

  function modalClickHandler() {
    props.modalClickHandler();
  }

  useKeyboardAction(() => {
    modalClickHandler();
  }, 'Escape');

  return (
    <Backdrop open={`${props.modalIsOpen ? 'open' : 'closed'}`} onBackdropClose={modalClickHandler}>
      <FocusLock>
        <div
          ref={modalRef}
          id="modal-container-onboarding"
          className={` ${props.modalIsOpen ? 'open' : 'closed'}`}
          aria-modal="true"
          role="dialog"
          aria-labelledby="mentalwellbeing-title"
        >
          <Button
            ariaLabel={t('modal.close')}
            className="close-icon"
            icon={{ faIconDefinition: faTimesCircle }}
            onClick={modalClickHandler}
            variant="icon-only"
          />
          <div id="mentalwellbeing_image" className="left_side_onboarding" />
          <div className="right_side_onboarding">
            <p className="onboarding_text">{pageContents.sub_title}</p>
            <h2 id="mentalwellbeing-title">{pageContents.title}</h2>
            <p>{pageContents.text1}</p>
            <p>{pageContents.text2}</p>
            <button
              id="mentalwellbeing-btn"
              onClick={modalClickHandler}
              ref={buttonRef}
              type="button"
            >
              {pageContents.buttonText} <FontAwesomeIcon icon={faArrowRight} className="icon" />
            </button>
          </div>
        </div>
      </FocusLock>
    </Backdrop>
  );
}
export default Modal;
